import useGetRequest from 'hooks/useGetRequest';
import React from 'react';
import { LearnerCourseOverview } from 'models/LearnerCourseOverview';

type LearnerDashboardContextValue = {
    learnerCourseOverviews: LearnerCourseOverview[] | undefined;
    refetchLearnerCourseOverviews: () => Promise<void>;
    errors: boolean;
};

export const LearnerDashboardContext = React.createContext<LearnerDashboardContextValue>({
    learnerCourseOverviews: undefined,
    refetchLearnerCourseOverviews: async () => {},
    errors: false,
});

export function LearnerDashboardProvider(props: { children: React.ReactNode }): JSX.Element {
    const {
        data: learnerCourseOverviews,
        errors: learnerCourseOverviewsErrors,
        refetchData: refetchLearnerCourseOverviews,
    } = useGetRequest<LearnerCourseOverview[]>('learner/courses');

    let errors: boolean = false;
    if (learnerCourseOverviewsErrors && learnerCourseOverviewsErrors.length) {
        errors = true;
    }

    if (!learnerCourseOverviews) return <></>;

    return (
        <LearnerDashboardContext.Provider
            value={{
                learnerCourseOverviews: learnerCourseOverviews,
                refetchLearnerCourseOverviews: refetchLearnerCourseOverviews,
                errors: errors,
            }}
        >
            {props.children}
        </LearnerDashboardContext.Provider>
    );
}
